import { ApolloLink } from '@apollo/client';

// this code will elevate graphql errors to network errors so they can be retried
// https://github.com/apollographql/apollo-link/issues/541
const elevateGqlErrorsLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((data) => {
    if (data && data['errors'] && data['errors'].length > 0) {
      throw data['errors'][0];
    }
    return data;
  });
});

export default elevateGqlErrorsLink;
